// Enquiey form js
document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("ContactForm");
    const submitButton = document.querySelector(".contact-button .button.custom-sumbit-button"); // Select button using class

    submitButton?.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default form submission

        let isValid = true;

        // Clear previous errors
        document.querySelectorAll(".error-message").forEach(el => el.remove());

        // Name Validation (Only letters, not empty)
        const nameField = document.getElementById("ContactForm-name");
        if (nameField.value.trim() === "") {
            showError(nameField, "Name cannot be empty.");
            isValid = false;
        } else if (!/^[a-zA-Z\s]+$/.test(nameField.value.trim())) {
            showError(nameField, "Name must contain only letters.");
            isValid = false;
        }

        // Phone Validation (Only numbers, 10 or 11 digits, not empty)
        const phoneField = document.getElementById("ContactForm-phone");
        if (phoneField.value.trim() === "") {
            showError(phoneField, "Phone number cannot be empty.");
            isValid = false;
        } else if (!/^\d{11}$/.test(phoneField.value.trim())) {
            showError(phoneField, "Phone number must be 11 digits.");
            isValid = false;
        }

        // Email Validation (Must contain "@" and end with ".com", not empty)
        const emailField = document.getElementById("ContactForm-email");
        if (emailField.value.trim() === "") {
            showError(emailField, "Email cannot be empty.");
            isValid = false;
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailField.value.trim())) {
            showError(emailField, "Enter a valid email (e.g., example@domain.com).");
            isValid = false;
        }

        // Quantity Validation (Must be a positive number, not empty)
        const quantityField = document.getElementById("ContactForm-quantity");
        if (quantityField.value.trim() === "") {
            showError(quantityField, "Quantity cannot be empty.");
            isValid = false;
        } else if (parseInt(quantityField.value) <= 0) {
            showError(quantityField, "Please enter a valid quantity.");
            isValid = false;
        }

        // Pieces Selection Validation (Cannot be empty)
        const piecesField = document.getElementById("ContactForm-pieces");
        if (piecesField.value === "") {
            showError(piecesField, "Please select an option.");
            isValid = false;
        }

        // If all validations pass, submit the form
        if (isValid) {
            form.submit();
        }
    });

    // Function to display error messages
    function showError(field, message) {
        const error = document.createElement("small");
        error.className = "error-message";
        error.style.color = "red";
        error.style.display = "block";
        error.textContent = message;
        field.parentNode.appendChild(error);
    }
});

// contact form js

document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("ContactForm");
    const submitButton = document.querySelector(".custom-sumbit-button-contact"); // Select the custom button

    submitButton?.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default form submission

        let isValid = true;

        // Clear previous errors
        document.querySelectorAll(".error-message").forEach(el => el.remove());

        // Name Validation (Only letters, not empty)
        const nameField = document.getElementById("ContactForm-name");
        if (nameField.value.trim() === "") {
            showError(nameField, "Name cannot be empty.");
            isValid = false;
        } else if (!/^[a-zA-Z\s]+$/.test(nameField.value.trim())) {
            showError(nameField, "Name must contain only letters.");
            isValid = false;
        }

        // Phone Validation (Only numbers, 10 or 11 digits, not empty)
        const phoneField = document.getElementById("ContactForm-phone");
        if (phoneField.value.trim() === "") {
            showError(phoneField, "Phone number cannot be empty.");
            isValid = false;
        } else if (!/^\d{11}$/.test(phoneField.value.trim())) {
            showError(phoneField, "Phone number must be 11 digits.");
            isValid = false;
        }

        // Email Validation (Must contain "@" and end with ".com", not empty)
        const emailField = document.getElementById("ContactForm-email");
        if (emailField.value.trim() === "") {
            showError(emailField, "Email cannot be empty.");
            isValid = false;
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailField.value.trim())) {
            showError(emailField, "Enter a valid email (e.g., example@domain.com).");
            isValid = false;
        }

        // Company Validation (Cannot be empty)
        const companyField = document.getElementById("ContactForm-company");
        if (companyField.value.trim() === "") {
            showError(companyField, "Company name cannot be empty.");
            isValid = false;
        }

        // Message/Comment Validation (Cannot be empty)
        const messageField = document.getElementById("ContactForm-body");
        if (messageField.value.trim() === "") {
            showError(messageField, "Message cannot be empty.");
            isValid = false;
        }

        // If all validations pass, submit the form
        if (isValid) {
            form.submit();
        }
    });

    // Function to display error messages
    function showError(field, message) {
        const error = document.createElement("small");
        error.className = "error-message";
        error.style.color = "red";
        error.style.display = "block";
        error.textContent = message;
        field.parentNode.appendChild(error);
    }
});

// footer mobile view

// document.addEventListener('DOMContentLoaded', function() {
//     const footers = document.querySelectorAll('.custm__Accoridan__footer');
    
//     footers.forEach(footer => {
//         footer.addEventListener('click', function() {
//             const accordianList = footer.querySelector('ul.cstClass_accordianList');
//             const icon = footer.querySelector('.accordion-item-header-icon');
            
//             if (accordianList.classList.contains('opentab')) {
//                 accordianList.classList.remove('opentab');
//                 icon.style.transform = 'rotate(360deg)';
//             } else {
//                 accordianList.classList.add('opentab');
//                 icon.style.transform = 'rotate(-180deg)';
//             }
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
    const footers = document.querySelectorAll('.custm__Accoridan__footer');
    
    footers.forEach(footer => {
        footer.addEventListener('click', function() {
            const accordianList = footer.querySelector('ul.cstClass_accordianList');
            const icon = footer.querySelector('.accordion-item-header-icon');
            
            if (accordianList.classList.contains('opentab')) {
                // Close with smooth transition
                accordianList.style.height = accordianList.scrollHeight + 'px'; 
                requestAnimationFrame(() => {
                    accordianList.style.height = '0';
                });
                accordianList.classList.remove('opentab');
                icon.style.transform = 'rotate(360deg)';
            } else {
                // Open with smooth transition
                accordianList.classList.add('opentab');
                accordianList.style.height = '0'; // Reset height for transition
                requestAnimationFrame(() => {
                    accordianList.style.height = accordianList.scrollHeight + 'px';
                });
                icon.style.transform = 'rotate(-180deg)';
            }
        });
    });
});


window.addEventListener('load', function () {
  document.querySelectorAll('.video-wrapper').forEach(function(wrapper) {
    if (wrapper.querySelector(':scope > .video-wrapper')) {
      wrapper.classList.add('parent-video-wrapper');
    }
  });
});


// let checkDropdown = setInterval(function () {
//   let $dropdown = $('#dropdown_20');

//   if ($dropdown.length) {
//     clearInterval(checkDropdown); // Stop checking once it's found

//     // Set the initial name attribute
//     $dropdown.attr('name', 'customer[tags]');

//     // Get the selected option value
//     let selectedValue = $dropdown.val();
//     console.log("Selected Value:", selectedValue);

//     // Optional: run on change too
//     $dropdown.on('change', function () {
//       selectedValue = $(this).val();
//       console.log("Updated Value:", selectedValue);

//       // Make sure the name attribute is still correct (in case it gets reset)
//       $(this).attr('name', 'customer[tags]');
//     });
//   }
// }, 100); // Check every 100 milliseconds

// document.addEventListener("DOMContentLoaded", function () {
// setTimeout(function () {
//     document.querySelectorAll('.money').forEach(function (el) {
//       let text = el.textContent.trim();
//       let number = parseFloat(text.replace(/[^0-9.]/g, ''));
//       if (!isNaN(number)) {
//         let newPrice = (number / 1.2).toFixed(2);
//         el.textContent = '£' + newPrice;
//       }
//     });
//   }, 500);
// });

